export const HeaderData = [
	{
		link: '/',
		name: 'Home',
	},
	{
		link: '/about-us',
		name: 'About Us',
	},
	{
		link: '/contact-us',
		name: 'Contact Us',
	},
	{
		link: '/events',
		name: 'Events',
	},
	{
		link: '/members',
		name: 'Members',
	},
	// {
	// 	link: '/gallery',
	// 	name: 'Gallery',
	// },
];
